<button mat-mini-fab class="header-image" (click)="openUserProfile()" style="position: relative;">
  <span class="initials">{{ userInitials }}</span>
</button>
<mat-icon style="position: absolute; right: -10px; top: 50%; transform: translateY(-50%); font-size: 16px;">
  arrow_drop_down
</mat-icon>


<mat-sidenav #rightSidebar
             mode="push"
             position="end"
             class="shadow-effect"
             style="background-color: #FFFFFF; margin-top: 64px; overflow-x:hidden; height:100vh; z-index:10;"
             [(opened)]="sidenavOpen">
  <div class="menu-content">
    <mat-icon style="color: gray; position: absolute; top: 15px; right: 15px; cursor:pointer" (click)="closeSidebar()">close</mat-icon>
    <div style=" height: 100%;width: 90%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
      <div class="user-image-container">
        <img src="{{imageUrl}}" alt="User Image" class="user-image" />
      </div>
      <p style=" font-weight: 400; font-size: 22px; margin: 0 !important">{{userInfos?.firstName + ' ' + userInfos?.lastName}}</p>
      <p style="font-weight: 300; font-size: 15px; margin: 0 !important">{{'basarsoftTech' | localize }}</p>

      <!-- Horizontal Button Container -->
      <div class="button-container">
        <a (click)="openNewPasswordSidebar()" style="color: #00A1FF; font-size: 12.5px; text-decoration: underline; cursor: pointer">{{'changePassword' | localize }}</a>
        <a *ngIf="_appsService.adminRoleControl.includes(_appsService.userInfos?.roleId)" (click)="managementPanel()" style="color: #00A1FF; text-decoration: underline; cursor: pointer; font-size:12.5px">{{'mainApp' | localize}}</a>
      </div>
 <div style="width: 100%; display: flex; justify-content: center; margin-top: 12px;">
   <a [ngClass]="_appsService.classes" style="color: #00A1FF; font-weight:500; font-size:medium; text-align:center; cursor:pointer; text-decoration: underline;" (click)="openKvkkModal()">
     {{'securityContracts' | localize}}
   </a>
 </div>
      <hr class="barely-visible-hr">
      <!-- Vertical Dropdowns -->
      <div class="dropdowns-container">
        <ng-container *ngIf="_appsService.companyControl.includes(_appsService.userInfos?.roleId)">
          <mat-label style="text-align: start; font-size: medium;">{{'company' | localize}}</mat-label>
          <mat-form-field class="dropdown" style="margin-top:5px; border:1px #CCCCCC solid; border-radius:6px;">
            <mat-select [(ngModel)]="selectedCompanyId" (selectionChange)="onSelectedCompany($event.value)">
              <div style="position: relative;">
                <mat-form-field style="width: 100%; padding-left: 10px; padding-bottom: 10px; padding-right: 10px; cursor:pointer">
                  <input matInput
                         placeholder="Arama"
                         (keyup)="onKey($event)" />
                  <mat-icon matSuffix
                            style="position: absolute; right: 8px; color: black; pointer-events: none;">
                    search
                  </mat-icon>
                </mat-form-field>
              </div>

              <mat-option *ngFor="let company of _appsService.filterCompanies" [value]="company.id">{{ company.companyName }}</mat-option>
            </mat-select>
            <mat-icon style="color: #888888;">
              {{'expand_more'}}
            </mat-icon>
          </mat-form-field>
        </ng-container>


        <mat-label style="text-align: start; margin-top: 20px;; font-size: medium;">{{'appLanguage' | localize }}</mat-label>
        <mat-form-field class="dropdown" style="margin-top:5px; margin-bottom:10px; border:1px #CCCCCC solid; border-radius:6px;">
          <mat-select [(ngModel)]="languageValue" (selectionChange)="change($event.value)">
            <mat-option *ngFor="let language of languages" [value]="language.value">
              {{language.viewValue }}
            </mat-option>
          </mat-select>

          <mat-icon style="color: #888888;">
            {{'expand_more'}}
          </mat-icon>
        </mat-form-field>

      <div *ngIf="_appsService.userInfos?.roleId == roleEnums.CompanyAdmin" style="width: 100%; display: flex; justify-content: center; align-items: center; margin-bottom: 12px;">
        <span [ngClass]="_appsService.classes" style="font-size: 14px; margin-right: 10px;">Tutorial Intro</span>
        <mat-slide-toggle [ngClass]="_appsService.classes" [checked]="introTourRepeatable" (change)="onIntroTourRepeatableChange($event.checked)"></mat-slide-toggle>
      </div>
      </div>
      <!--<div style="width: 100%; display: flex; justify-content: space-between; font-size: large; align-items:center;">
        {{'interfaceTheme' | localize }}
        <mat-slide-toggle #darkModeSwitch
                          class="example-margin"
                          [checked]="checked"
                          [disabled]="disabled">
        </mat-slide-toggle>

      </div>-->

    <div style=" width: 100%; height: 100%; display: flex; justify-content: center; flex-direction: column; padding-left: 14px; padding-right: 7px;">
      <a target="_blank"
         [href]="env.docusaurusUrl + '/docusaurus/'"
         class="user-guide-button white-button">
        <mat-icon class="icon">insert_drive_file</mat-icon>
        <span class="text" [ngClass]="_appsService.classes">
          {{ 'userManuel' | localize }}
        </span>
      </a>

      <a [ngClass]="_appsService.classes" style="color: #00A1FF; font-weight:500; font-size:medium; text-align:center; cursor:pointer" target="_blank" href="assets/UserManuel/Teamer-Kullanim-Klavuzu.pdf">
        {{'downloadUserManuelPdf' | localize}}
      </a>

      <button mat-button class="user-guide-button blue-button" style="color:white;">{{'watchTutorialAgain' | localize }}</button>
      <a style="text-decoration: underline; color: red; font-size:12.5px; cursor: pointer; text-align: center;" (click)="signOutEmit()">{{'logout' | localize}}</a>
      <!--<button (click)="signOutEmit()" mat-button class="logout-button">{{'logout' | localize}}</button>-->
    </div>
    </div>


  </div>
</mat-sidenav>

<mat-sidenav #rightSidebarNewPassword
             mode="push"
             position="end"
             class="shadow-effect new-password-container"
             style="background-color: #FFFFFF; margin-top: 64px; overflow-x:hidden; height:100vh; z-index:10;"
             [(opened)]="sidenavOpenPassword">
  <div class="menu-content">
    <mat-icon style="color: gray; position: absolute; top: 15px; right: 15px; cursor:pointer" (click)="closeSidebarPwd()">close</mat-icon>
    <ng-container *ngIf="sidenavOpenPassword">
      <app-user-new-password (closeRequest)="closeSidebarPwd()"></app-user-new-password>
    </ng-container>
  </div>
</mat-sidenav>
